import { colorsObject } from "data/colors/colorPalettes"
import { colorPallet as c } from "data/colors/colorPalettes"

export const apiVersions = {
  V1: 'v1',
  V2: 'v2'
}

export const apiPaths = {
  ADMIN_USERS: 'admin.users',
  ADMIN_PERMISSIONS: 'admin.permissions',
  ADMIN_LOGIN_HISTORY: 'admin.login-history',
  ADMIN_PROFILE: 'admin.profile',
  ADMIN_FORMS_TEMPLATES: 'admin.forms-templates',
  ADMIN_FORMS_SUBMISSIONS: 'admin.forms-submissions',
  ADMIN_WORKING_SITES: 'admin.working-sites',
  ADMIN_WORKING_SITES_PLANNER: 'admin.working-sites.planner',
  ADMIN_WORKING_HOURS: 'admin.working-hours',
  ADMIN_WORKING_HOURS_SUBMISSIONS: 'admin.working-hours.submissions',
  ADMIN_EMPLOYEES: 'admin.employees',
  ADMIN_EMPLOYEES_PLANNER: 'admin.employees.planner',
  ADMIN_EMPLOYEES_ABSENCE: 'admin.employees-absence',
  ADMIN_EMPLOYEES_NOTES: 'admin.employees-notes',
  ADMIN_COMMUNE: 'admin.communes',
  ADMIN_CANTONS: 'admin.cantons',
  ADMIN_CITIES: 'admin.cities',
  ADMIN_CANTONS_HOLIDAYS: 'admin.cantons-holidays',
  ADMIN_TAX_SCALES: 'admin.tax-scales',
  ADMIN_TAX_SCALES_DETAILS: 'admin.tax-scales-details',
  ADMIN_TAX_EMPLOYEES: 'admin.tax-employees',
  ADMIN_GROUPS: 'admin.groups',
  ADMIN_REPORT: 'admin.report',
  ADMIN_SPREADSHEETS: 'admin.spreadsheets',
  ADMIN_COMPANIES: 'admin.companies',

  WEB_PLANNER: 'web/planner',

  SETTINGS: 'settings',
}

export const apiActions = {
  LIST: 'list',
  GET: 'get',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  GET_LINK: 'get-link',
  DUPLICATE: 'duplicate',
  FILES: 'files',
  TOTALS: 'totals',
  EMPLOYEES: 'employee',
  WORKING_SITES: 'working-sites',
  WORK_TABLE: 'work-table',
  CREATE_CONSTANT: 'create.constant',
  IMAGE: 'image'
}

export const boolean = {
  boolean: {
    label: 'Boolean true/false',
    data: {
      default: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      true: {
        label: 'Yes',
        value: 'true',
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      false: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  },
  booleanString: {
    label: 'Boolean "true"/"false"',
    data: {
      default: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      true: {
        label: 'Yes',
        value: 'true',
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      false: {
        label: 'No',
        value: 'false',
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  },
  booleanYesNo: {
    label: 'Boolean "Yes"/"No"',
    data: {
      default: {
        label: 'No',
        value: 'no',
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      yes: {
        label: 'Yes',
        value: 'yes',
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      no: {
        label: 'No',
        value: 'no',
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  },
  booleanNumber: {
    label: 'Boolean 1/0',
    data: {
      default: {
        label: 'No',
        value: 0,
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      '1': {
        label: 'Yes',
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      '0': {
        label: 'No',
        value: 0,
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    }
  }
}

export const common = {
  ...boolean,
  devices: {
    label: 'Devices',
    data: {
      default: {
        label: 'N/A',
        value: null,
        theme: colorsObject().cadetGrey,
      },
      'desktop': {
        label: 'Desktop',
        value: 'desktop',
        theme: colorsObject().starCommandBlue,
      },
      'mobile': {
        label: 'Mobile',
        value: 'mobile',
        theme: colorsObject().rebeccaPurple,
      },
      'tablet': {
        label: 'Tablet',
        value: 'tablet',
        theme: colorsObject().ochre,
      },
      'unknown': {
        label: 'Unknown',
        value: 'unknown',
        theme: colorsObject().darkByzantium,
      }
    },
  },
  empty: {
    label: 'Empty',
    data: {},
  }
}

export const user = {
  usersStatus: {
    label: 'Users status',
    data: {
      default: {
        label: "Unknown",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Admin",
        value: 1,
        theme: colorsObject().amazon,
      },
      2: {
        label: "Account Manager",
        value: 2,
        theme: colorsObject().burntSienna,
      },
      3: {
        label: "Advertiser",
        value: 3,
        theme: colorsObject().rebeccaPurple,
      },
      4: {
        label: "Affiliate",
        value: 4,
        theme: colorsObject().starCommandBlue,
      },
      5: {
        label: "Support",
        value: 5,
        theme: colorsObject().amaranth,
      },
      6: {
        label: "Finance",
        value: 6,
        theme: colorsObject().flickrPink,
      },
      99: {
        label: "Banned",
        value: 99,
        theme: colorsObject().englishRed,
      },
    }
  },
  usersType: {
    label: 'Users type',
    data: {
      default: {
        label: "Unknown",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Internal",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: "External",
        value: 2,
        theme: colorsObject().royalPurple,
      },
    }
  },
}



